import { useEffect } from 'react';
import PageTemplate from '../components/PageTemplate/PageTemplate';
import { SIGN_OUT_TENANT_KEY } from './AuthContext';
import { buildColaSignOutUrl } from './oidcConfig';
import { SigningIn } from './RequireAuth';

/**
 * Cognito's hosted UI logout lands here. The Cognito session is over; now end
 * the COLA session and come back to the tenant page the user signed out from.
 */
export default function SignedOut() {
  useEffect(() => {
    let tenant = '';
    try {
      tenant = window.sessionStorage.getItem(SIGN_OUT_TENANT_KEY) || '';
      window.sessionStorage.removeItem(SIGN_OUT_TENANT_KEY);
    } catch (_err) {}
    window.location.assign(buildColaSignOutUrl(tenant || null));
  }, []);

  return (
    <PageTemplate>
      <SigningIn label="Signing you out…" />
    </PageTemplate>
  );
}
